export default "__VITE_ASSET__Dc8LSz5z__"